export default __webpack_public_path__ + "static/media/get-started-search.90771a20.svg";